import { render, staticRenderFns } from "./excelExportAgentCom.vue?vue&type=template&id=4b0979c4"
import script from "./excelExportAgentCom.vue?vue&type=script&lang=js"
export * from "./excelExportAgentCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports